import { all } from "redux-saga/effects";

export default function* regulationsSaga() {
  yield all([]);
}
